import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import type { ListStyleProps } from '../../types.tsx';
import { Column } from '../styled.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const PaddedSection = styled2.div({
	paddingTop: token('space.150'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const GrowingScrollableSection = styled2(PaddedSection)({
	flexGrow: 1,
	position: 'relative',
	overflow: 'auto',
	overflowWrap: 'break-word',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const PaddedColumnSection = styled2(Column)({
	paddingTop: token('space.150'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const TitleWrapper = styled2.div({
	marginTop: token('space.400'),
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: token('space.100'),
	paddingTop: 0,
	paddingRight: token('space.200'),
	paddingBottom: 0,
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const SidebarDescription = styled2.div({
	font: token('font.body'),
	marginTop: token('space.200'),
	textAlign: 'left',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text'),
	paddingTop: 0,
	paddingRight: token('space.200'),
	paddingBottom: 0,
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const ToolbarTitle = styled2.h4({
	paddingTop: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const ToolbarSectionDescription = styled2.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest'),

	font: token('font.body.UNSAFE_small'),
	marginTop: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const SidebarDividingLine = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `2px solid ${token('color.border')}`,
	marginTop: 0,
	marginRight: token('space.200'),
	marginBottom: 0,
	marginLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const NoStyleComponent = styled2.ul({
	margin: 0,
	paddingLeft: 0,
	listStyle: 'none',
});

export const NoStyle = ({ innerRef, ...rest }: ListStyleProps) => (
	<NoStyleComponent {...rest} ref={innerRef} />
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const PaginationButtonsContainer = styled2.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'flex-end',
	justifyContent: 'flex-end',
});

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const FieldCategoryTitle = styled.label`
	font: ${token('font.heading.xxsmall')};
	color: ${token('color.text.subtle')};
	display: block;
	margin-bottom: ${token('space.150')};
	margin-top: ${token('space.150')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const FieldCategoryWrapper = styled2.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	gap: token('space.100'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled
export const StateText = styled2.p({
	font: token('font.body'),
	marginTop: token('space.200'),
	textAlign: 'left',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text'),
});
